<template>
  <b-container>
    <header class="header pt-4 app--hidden app--mobile-shown col"
      style="align-items: center;
        padding-left: 0px; padding-right: 0px;">

      <!-- search bar -->
      <div class="header__search search-bar">
        <img
          src="@/assets/img/search.svg"
          class="mr-2"
          alt="search"
        />
        <input
          v-model.trim="keyword"
          type="text"
          style="flex: 1; border: 0; outline: 0; font-size: 0.875rem"
          size="1"
          placeholder="搜尋"
          aria-label="搜尋"
          aria-describedby="button-addon1"
        />
        <img
          v-if="keyword !== ''"
          @click="keyword = ''"
          src="@/assets/img/close.svg"
          style="height: 0.875rem; cursor: pointer"
          alt="clear"
        />
      </div>
    </header>

    <TheListingTitle
      style="padding-top: 10px;"
      title="優惠列表"
      :selectedKeywordAndFilters="selectedKeywordAndFilters"
      @reset-click="initialize"
    ></TheListingTitle>
    <section class="table-content">
      <template>
        <BaseFilterToolbar @reset="initialize" :loading="loading">
          <div class="d-flex">
            <label id="keyword-filter">
              <input
                v-model.trim="keyword"
                type="text"
                class="form-control"
                style="width: 100%"
                placeholder="關鍵字..."
                aria-label="關鍵字..."
                aria-describedby="button-addon1"
              />
            </label>
          </div>
        </BaseFilterToolbar>
        <DataTable
          v-show="list"
          :fields="fields"
          :mobileFields="mobileFields"
          :items="mobileListField"
          :total-result="total"
          :options.sync="options"
          :loading="loading"
          @row-clicked="goToItem"
          ref="dataTable"
          showRowDetails
        >
          <template v-slot:cell(name1)="{ item }">
            <div class="d-flex">
              <img v-if="item.cover" class="data-table__cover mr-2" :src="item.cover" />
              <div>
                {{ item.name1 }}
              </div>
            </div>
          </template>
          <!-- mobile only -->
          <!-- <template v-slot:id="{ item }">
            <router-link :to="{ path: `${$route.path}/${item.id}` }"> {{ item.id }}</router-link>
          </template> -->
          <template v-slot:row-details-custom="{ item }">
            <div class="row">
              <div class="col-4"></div>
              <router-link :to="{ path: `${$route.path}/${item.id}` }"
                class="app--hidden app--mobile-shown col"
              >
                更多優惠詳情>
              </router-link>
            </div>
          </template>
          <!-- end of mobile only -->
        </DataTable>
        <b-skeleton-table v-if="!list" :rows="15" :columns="5"></b-skeleton-table>
      </template>
    </section>
  </b-container>
</template>

<script>
import { mapState } from 'vuex';
import { scheduled, asyncScheduler } from 'rxjs';
import {
  tap, map, switchMap, debounceTime, pluck, mergeAll,
} from 'rxjs/operators';
import {
  BContainer,
  BSkeletonTable,
} from 'bootstrap-vue';
// import axios from 'axios';
import dataTableMixin from '../../mixins/data-table';
import exportMixin from '../../mixins/export';
import filtersQueryStringMixin from '../../mixins/filtersQueryString';
import optionsQueryStringMixin from '../../mixins/optionsQueryString';
import { formatDateForQrCodePage } from '../../helpers/date';
// import http from '../../helpers/http';
import getCouponStatus from '../../helpers/coupon-status';
import TheListingTitle from '../../components/TheListingTitle.vue';
import DataTable from '../../components/DataTable.vue';
import BaseFilterToolbar from '../../components/BaseFilterToolbar.vue';

const COUPON_HEADERS = [
  { key: 'id', label: '商品編號', sortable: true },
  { key: 'name1', label: '優惠名稱', sortable: true },
  { key: 'rewardNameforMobile', label: '優惠名稱', sortable: true },
  {
    key: 'expire',
    label: '優惠使用期限',
    sortable: true,
    formatter: (value) => formatDateForQrCodePage(value, true),
  },
];

const PAYMENT_COUPON_HEADERS = [
];

const MOBILE_HEADER = [
  {
    key: 'name1',
    label: '優惠名稱',
  },
];

export default {
  mixins: [dataTableMixin, exportMixin, filtersQueryStringMixin, optionsQueryStringMixin],
  components: {
    BContainer,
    BSkeletonTable,
    TheListingTitle,
    DataTable,
    BaseFilterToolbar,
  },
  data: () => ({
    filter: {
      keywordType: 'all',
      status: undefined,
      tagId: undefined,
    },
    options: {
      sortBy: 'id',
    },
    keyword: '',
    keywordSelectOptions: [
      {
        value: 'all',
        text: '所有關鍵字',
      },
    ],
    mobileFields: MOBILE_HEADER,
  }),
  computed: {
    ...mapState(['user']),
    // ...mapState(['role']),
    couponType() {
      return this.$route.meta.paymentType === 'UFUN' ? '積分' : '付費';
    },
    fields() {
      let couponHeaders = COUPON_HEADERS;
      let paymentCouponHeaders = PAYMENT_COUPON_HEADERS;
      if (this.role === 'admin' || this.role === 'sale') {
        couponHeaders = [
          ...COUPON_HEADERS,
          { key: 'updatedAt', label: '更新時間', sortable: true },
        ];
        paymentCouponHeaders = [
          ...PAYMENT_COUPON_HEADERS,
          { key: 'updatedAt', label: '更新時間', sortable: true },
        ];
      }
      return this.$route.name === 'ListQrCode' ? couponHeaders : paymentCouponHeaders;
    },
    isEmptyState() {
      // console.log('isEmptyState', this.result);
      return this.result?.list.total === 0;
    },
    list() {
      return this.result?.list.result;
    },
    mobileListField() {
      // penging to handle
      // console.log('this.list', this.list);
      const tempList = {
        ...this.list,
      };
      Object.keys(tempList).forEach((key) => {
        delete tempList[key].brandName;
        // console.log(key, tempList[key]);
      });
      delete tempList.brandName;
      // console.log('delete tempList.brandName;');
      // console.log('tempList:', tempList);
      // console.log('tempList:', Object.keys(tempList).map((key) => [Number(key), tempList[key]]));
      return Object.values(tempList);
    },
  },
  subscriptions() {
    const getData$ = (data) => this.httpRequest$(
      {
        method: 'GET',
        url: '/agc-sub-merchant-api/qrcode/availiableToRedeem?codeType=mc-qr&qrCode=true',
      },
      data,
    );

    return {
      result: scheduled(
        [...this.scheduleTasks],
        asyncScheduler,
      ).pipe(
        mergeAll(),
        tap(() => {
          this.loading = true;
        }),
        debounceTime(250),
        map(() => ({
          data: {
            ...this.filter,
            q: this.keyword,
          },
          options: this.options,
        })),
        pluck('data'),
        switchMap(getData$),
      ),
    };
  },
  methods: {
    goToItem({ id }) {
      this.$router.push({
        path: `${this.$route.path}/${id}`,
      });
    },
    // onOverviewItemClicked(status) {
    //   this.filter.status = status.toUpperCase();
    // },
    initialize() {
      this.filter.keywordType = 'all';
      this.keyword = '';
      this.filter.status = undefined;
      this.filter.tagId = undefined;
      setTimeout(() => {
        this.loading = false;
      }, 550);
      // when user updates filter too fast, the loading state will not set back to false
      // this time must be bigger than debounceTime's time
    },
    getCouponStatus,
    formatDateForQrCodePage,
  },
  // beforeRouteLeave(to, from, next) {
  //   this.initialize();
  //   next();
  // },
};
</script>

<style scoped lang="scss">
@import "../../assets/scss/data-table/list-table-content";
@import '../../assets/scss/listing/header';

.search-bar {
  display: flex;
  align-items: center;
  min-width: 24rem;
  padding: 0.25rem 1rem;
  background-color: white;
  border: 1px solid #DDE1E5;
  border-radius: 9999px;

  @include respond(tab-landscape) {
    flex: 1;
    min-width: 0;
  }
}

.data-table {
  &::v-deep {
    & td {
      @include respond(phone) {
        max-width: 18.5rem;
        div {
          white-space: normal !important;
          // overflow: visible;
          // font-size: 11px;
        }
      }
    }
    // arrow style
    .right-corner {
      right: 10%;
    }
  }
  &::v-deep table thead th:first-of-type {
    padding-left: 3.5rem !important;
  }
}
</style>
